// Error monitoring (Sentry). Stays completely DORMANT until REACT_APP_SENTRY_DSN
// is set (as a Vercel env var), so nothing is sent anywhere until you configure it.
// A DSN is safe to expose in frontend code — it only allows sending events in.
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'production',
    // Keep it light: error reporting only — no performance tracing, no session replay.
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Don't attach IP addresses, cookies, or other default personal data.
    sendDefaultPii: false,
    // Defensive scrub: birth details travel in POST request bodies (which Sentry
    // does not capture by default), but strip request data/cookies anyway so no
    // birth data can ever leave the browser in an error report.
    beforeSend(event) {
      if (event.request) {
        delete event.request.data;
        delete event.request.cookies;
      }
      return event;
    },
  });
}

export const isSentryEnabled = !!dsn;
export { Sentry };
